import {debounce} from 'lodash';
import {mapActions, mapGetters, mapMutations} from 'vuex';

import questionOptions from '../../components/question-options/index.vue'
import questionText from '../../components/question-text/index.vue'

import additionalMaterials from '@/components/features/additional-materials/index.vue';

import homeWorkHeader from '@/components/header/components/home-work-header/index.vue';
import TimerIndex from '@/components/timer/TimerIndex';
import retakingHistory from '@/components/features/home-work-retaking-history/index.vue';

import chatComponent from '@/components/features/chat-component/index.vue'

import { seo } from '@/mixins/seo';

export default {
	name		: 'home-work-questions',
	mixins		: [seo],
	data() {
		return {
			answers: {
				text: null,
				ids	: []
			},
			reInitComponents: false,
			hasLoadingModule: false,
			runTimerEvent: true,
			isValidAnswer: false
		}
	},
	components	: {
		questionOptions,
		questionText,
		homeWorkHeader,
		TimerIndex,
		additionalMaterials,
		retakingHistory,
		chatComponent
	},
	created() {
		//console.log('home-work-questions created');
	},
	mounted() {
		//console.log('home-work-questions mounted');
		
		this.fetchServerTime();
		
		if (!this.currentItem) {
			this.fetchData({
				...this.$route.params,
			})
			.then(() => {
				this.setData()
			})
		} else {
			this.setData()
			this.fetchCourse;
		}
		
		this.$bus.$on('event-end-timer', () => {
			//console.warn('NEXT QUESTION');
			
			if (this.runTimerEvent) this.nextQuestion();
			
			//якщо 0 тривалість то не запускати
			
			// this.onClickBtn();
		});
	},
	watch		: {
		course() {
			this.seo.title = this.currentItem.name + ' - ' + this.course.name;
			
			this.$emit('updateHead')
		}
	},
	computed	: {
		...mapGetters({
			course			: 'courses/currentItem',
			isLoadingTest	: 'coursesHomeWork/isLoadingTest',
			currentItem		: 'coursesHomeWork/currentItem',
			currentTest		: 'coursesHomeWork/currentTest',
			isLoading		: 'coursesHomeWork/isLoading',
			serverTime		: 'setting/serverTime',
			routeFromInfo	: 'coursesHomeWork/routeFromInfo',
		}),
		convertSecondsToMinutes() {
			return Math.ceil(this.currentItem.availableTime / 60)
		},
		progressPercent() {
			if (!this.currentItem.questionsCount) return 0;
			if (!this.currentTest.completedQuestions) return 0;
			
			return Math.round(((this.currentTest.completedQuestions) / this.currentItem.questionsCount) * 100)
		},
		disabledButton() {
			if (this.currentTest.currentQuestion.data.type === 'options') {
				if (this.answers.hasOwnProperty('ids')) {
					return !this.answers.ids.length
				} else return true
			} else if (this.currentTest.currentQuestion.data.type === 'options_and_own_answer') {
				if (this.answers.type === 'checkbox') {
					return !this.answers.ids.length
				} else {
					return !this.answers.value
				}
			} else {
				return !this.answers
			}
		},
		hasPractic() {
			return this.currentItem.type === 'text'
		},
	},
	methods		: {
		...mapActions({
			fetchData		: 'coursesHomeWork/GET_LIST_ITEM',
			fetchServerTime	: 'setting/GET_SERVER_TIME',
			completeQuestion: 'coursesHomeWork/COMPLETE_QUESTION',
			completeTest	: 'coursesHomeWork/COMPLETE_TEST',
			startTest		: 'coursesHomeWork/START_TEST',
			fetchCourse		: 'courses/GET_COURSE_ITEM',
		}),
		...mapMutations({
			changeHeader		: 'coursesHomeWork/CHANGE_HEADER',
			setTest				: 'coursesHomeWork/SET_CURRENT_QUESTION',
			setHomeWorkStatus	: 'courses/UPDATE_HOMEWORK_STATUS'
		}),
		onClickBtn: debounce(function () {
			console.log('click onClickBtn');
			
			document.getElementById('questionBtn').dispatchEvent(new Event("click"))
		}, 500),
		setData() {
			this.changeHeader({
				show	: true,
				title	: this.$t('homeWork'),
			});
			
			this.startTest({
				...this.$route.params
			})
			.then(() => {
				if (this.currentTest.status === '') {
					this.finishTest();
				}
			}).catch(error => {
				if (error.response.status === 403) {
					const key = error.response.data.error.message_key;

					// the work was already submitted/graded — say so explicitly
					// and show its status page instead of silently bouncing
					if (key === 'home_work_is_on_checking') {
						this.$toasted.success(this.$t('hwAlreadySubmitted'))

						try {
							this.$router.push({
								name	: 'home-work-check',
								params	: { ...this.$route.params }
							})
						} catch (e) {
							console.log(e);
						}

						return;
					}

					if (key === 'home_work_already_completed') {
						this.$toasted.success(this.$t('hwAlreadyChecked'))

						try {
							this.$router.push({
								name	: 'home-work-report',
								params	: { ...this.$route.params }
							})
						} catch (e) {
							console.log(e);
						}

						return;
					}

					this.closeTest();
				}
			})
		},
		updateQuestions(data, type) {
			console.log('data', data);
			
			if (type === 'options') {
				this.answers.ids = data.ids
			} else {
				this.answers.text = data
			}
		},
		createFormData() {
			const formData = new FormData();
			
			formData.append('item', this.$route.params.item)
			formData.append('moduleSlug', this.$route.params.moduleSlug)
			formData.append('testId', this.$route.params.testId)
			formData.append('id', this.currentTest.currentQuestion.data.id);
			
			console.log(this.currentTest.currentQuestion.data.type === 'options', this.answers.type === 'checkbox');
			
			if (this.currentTest.currentQuestion.data.type === 'options') {
				formData.append(`answers`, this.answers.ids ? this.answers.ids.join(',') : '')
			} else if (this.currentTest.currentQuestion.data.type === 'options_and_own_answer') {
				if (this.answers.type === 'checkbox') {
					formData.append(`answers`, this.answers.ids ? this.answers.ids.join(',') : '')
				} else {
					formData.append(`text`, this.answers.text)
				}
			} else {
				formData.append(`text`, this.answers.text)
			}
			
			// reset to the same SHAPE as data(): an array here left `answers.ids`
			// undefined, so the next click died on `undefined.length` —
			// the "dead submit button" complaint
			this.answers = { text: null, ids: [] };

			return formData
		},
		onTimerEnd() {
			// a manual submit may already be in flight; firing a second
			// complete for the same question gets a 403 and kicks the student
			// out of the test — the fresh question restarts the timer anyway
			if (this.isLoadingTest) return;

			this.nextQuestion(true);
		},
		nextQuestion(force = false) {
			console.log('run nextQuestion');
			
			this.runTimerEvent = false;
			
			if (force || this.answers.text || (this.answers.ids && this.answers.ids.length)) {
				this.isValidAnswer = false;

				// the submit button sits at the bottom of the page — scroll up
				// right away so the user watches the loader/next question
				// instead of sitting in the footer while the request is in flight
				const app = document.querySelector('.app');
				if (app) app.scrollTop = 0;
				window.scrollTo(0, 0);

				this.completeQuestion(this.createFormData()).then(() => {
					this.resetRunTimerEvent();
					
					if (!this.currentTest.currentQuestion.data.hasOwnProperty('id')) {
						console.log('Це останнє питання, закінчити тест');
						
						this.finishTest();
					} else {
						console.log('Отримано настпне питання - перегружаємо компонент');
						
						this.reInitComponents = true;
						
						setTimeout(() => {
							this.reInitComponents = false;
						}, 100)
					}
					
					this.answers = { text: null, ids: [] };
				}).catch(e => {
					this.resetRunTimerEvent();

					// network error / timeout has no response object — without this
					// guard the catch itself throws and the question never advances
					if (!e.response) {
						this.$toasted.error(this.$t('hwSubmitFailed'))
						return;
					}

					if (e.response.status === 403) {
						
						let error = e.response;
						
						console.log('error', error.data.error);
						
						switch (error.data.error.message_key) {
							case 'home_work_is_not_started':
								console.log('кидаємо на правила проходження, для старту домашки');
							break;
							case 'home_work_is_on_checking':
								console.log('домашка на перевірці - кидаємо на чек');
							break;
							case 'home_work_already_completed':
								console.log('уже завершена - кидаємо на репорт');
							break;
							case 'question_id_already_completed':
								console.log('питання уже пройдено - кидаємо на слідуюче питання (подумати де його брати)');
							break;
							case 'question_is_not_opened_yet':
								console.log('ти пробуєш перескочити поточне питання, кидати на поточне (подумати де його брати)');
							break;
						}
						
						console.log('Тест знаходиться на перевірці і роутить на сторінку чеку домашки');

						// human message instead of the raw backend message_key
						const messageKey = error.data.error.message_key;

						if (messageKey === 'home_work_is_on_checking') {
							this.$toasted.success(this.$t('hwAlreadySubmitted'))
						} else if (messageKey === 'home_work_already_completed') {
							this.$toasted.success(this.$t('hwAlreadyChecked'))
						} else {
							this.$toasted.error(this.$t('hwSubmitFailed'))
						}

						try {
							this.$router.push({
								name	: messageKey === 'home_work_already_completed'
									? 'home-work-report'
									: 'home-work-check',
								params	: {
									...this.$route.params,
								}
							})
						} catch (e) {
							console.log(e);
						}
					}
				})
			} else {
				this.isValidAnswer = true

				// explicit feedback: a silent red border reads as a dead button
				this.$toasted.error(this.$t('insertText'))
			}
		},
		resetRunTimerEvent() {
			setTimeout(() => {
				this.runTimerEvent = true;
			}, 5000)
		},
		finishTest() {
			const formData = new FormData();
			
			formData.append('item', this.$route.params.item)
			formData.append('moduleSlug', this.$route.params.moduleSlug)
			formData.append('testId', this.$route.params.testId)
			formData.append('_method', 'patch')
			
			this.hasLoadingModule = true;
			
			this.completeTest(formData).then(response => {
				this.$toasted.success(this.$t('hwSubmitSuccess'))

				// the response carries the REAL post-submit status (written
				// synchronously by the backend) — sync it into the cached course
				// tree so the dashboard badge updates instantly, without waiting
				// for the queue-recomputed aggregates
				this.setHomeWorkStatus({
					slug	: this.$route.params.testId,
					status	: response.status
				})

				// refetch the course tree (bypassing the TTL cache) so the homework
				// status on the dashboard is up to date without a manual page reload
				this.fetchCourse({ slug: this.$route.params.item, force: true }).catch(() => {})

				if (response.status === 'accepted' || response.status === 'failed') {
					try {
						this.$router.push({
							name	: 'home-work-report',
							params	: {
								...this.$route.params,
							}
						})
					} catch (e) {
						console.log(e);
					}
				} else {
					try {
						this.$router.push({
							name	: 'home-work-check',
							params	: {
								...this.$route.params,
							}
						})
					} catch (e) {
						console.log(e);
						this.hasLoadingModule = false;

					}
				}
			}).catch(() => {
				// without this a failed submit left hasLoadingModule = true
				// forever, hiding the submit UI until the user navigated away
				this.hasLoadingModule = false;

				this.$toasted.error(this.$t('hwSubmitFailed'))
			})
		},
		closeTest() {
			try {
				this.$router.push({
					name	: 'courses-main',
					params	: {
						item	: this.$route.params.item
					}
				})
			} catch (e) {
				console.log(e);
			}
			
			this.changeHeader({
				show	: false,
				title	: '',
			})
		},
		goBack() {
			this.$router.push({
				name	: this.routeFromInfo.name,
				params	: this.routeFromInfo.params
			});
		}
	},
	destroyed() {
		this.setTest(null)
	}
}
